var exports = module.exports = {};

exports.regions = { 'us': 'United States', 'sg': 'Singapore' };



// WEBPACK FOOTER //
// ./assets/js/constants.js